export const dashboardUrl = '/';
export const learningCollectionsUrl = '/learning_collections';
export const reportsUrl = '/reports';
export const peopleUrl = '/people';
export const reportUrl = (reportId: number) => `/reports/${reportId}`;
